import { clearStorage, resetAll } from '@connect-x-app/hybrid-utils';

import { useSettingsStore } from './useSettingsStore';

export const resetAllPreservingDevicePreferences = (): void => {
  const { themePreference } = useSettingsStore.getState().settings.preferences;
  clearStorage();
  resetAll();
  useSettingsStore.getState().setThemePreference(themePreference);
};
